// extracted by mini-css-extract-plugin
module.exports = {"dropdownSelector":"styles_dropdownSelector__oq2kw","selected":"styles_selected__ycpm6"};